exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".office_first .input_wrapper[data-v-73ce92b1]{margin-top:10px;margin-left:0}.office_first .input_wrapper>div label[data-v-73ce92b1]{width:90px}\n", ""]);

// exports
